import icProgramPlay from "@/assets/images/user/icProgramPlay.svg";
// import programPlayCont5Img1 from "@/assets/images/user/programPlayCont5Img1.jpg";
import programPlay2026Cont1Img1 from "@/assets/images/user/programPlay2026Cont1Img1.jpg";
import programPlay2026Cont2Img1 from "@/assets/images/user/programPlay2026Cont2Img1.jpg";
import programPlay2026Cont3Img1 from "@/assets/images/user/programPlay2026Cont3Img1.png";
import programPlay2026Cont3Img2 from "@/assets/images/user/programPlay2026Cont3Img2.png";
import programPlay2026Cont4Img1 from "@/assets/images/user/programPlay2026Cont4Img1.jpg";
import programPlay2026Cont4Img2 from "@/assets/images/user/programPlay2026Cont4Img2.jpg";
import programPlay2026Cont4Img3 from "@/assets/images/user/programPlay2026Cont4Img3.jpg";
import programPlay2026Cont4Img4 from "@/assets/images/user/programPlay2026Cont4Img4.jpg";
import programPlay2026Cont4Img5 from "@/assets/images/user/programPlay2026Cont4Img5.jpg";
import programPlay2026Cont5Img1 from "@/assets/images/user/programPlay2026Cont5Img1.jpg";
// import programPlayCont1Img1 from "@/assets/images/user/programPlayCont1Img1.jpg";
// import programPlayCont1Img2 from "@/assets/images/user/programPlayCont1Img2.jpg";
// import programPlayCont1Img3 from "@/assets/images/user/programPlayCont1Img3.jpg";
// import programPlayCont1Img4 from "@/assets/images/user/programPlayCont1Img4.jpg";
// import programPlayCont1Img5 from "@/assets/images/user/programPlayCont1Img5.jpg";
// import programPlayCont1Img6 from "@/assets/images/user/programPlayCont1Img6.jpg";
// import programPlayCont1Img7 from "@/assets/images/user/programPlayCont1Img7.jpg";
// import programPlayCont1Img8 from "@/assets/images/user/programPlayCont1Img8.jpg";
// import programPlayCont1Img9 from "@/assets/images/user/programPlayCont1Img9.jpg";
// import programPlayCont1Img10 from "@/assets/images/user/programPlayCont1Img10.jpg";
// import programPlayCont1Img11 from "@/assets/images/user/programPlayCont1Img11.jpg";
// import programPlayCont1Img12 from "@/assets/images/user/programPlayCont1Img12.jpg";
// import programPlayCont1Img13 from "@/assets/images/user/programPlayCont1Img13.jpg";
// import programPlayCont2Img1 from "@/assets/images/user/programPlayCont2Img1.jpg";
// import programPlayCont2Img2 from "@/assets/images/user/programPlayCont2Img2.jpg";
// import programPlayCont3Img1 from "@/assets/images/user/programPlayCont3Img1.jpg";
// import programPlayCont4Img1 from "@/assets/images/user/programPlayCont4Img1.jpg";
// import programPlayCont4Img2 from "@/assets/images/user/programPlayCont4Img2.jpg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";

const txtBoxClass =
    "max-w-[72px] w-full text-[16px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[10px]";

// interface Booth {
//     title: string;
//     img: string;
//     list: { title: string; content: string | React.ReactNode; positionTop?: boolean }[];
// }

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// const boothList: Booth[] = [
//     {
//         title: "젠레스 존 제로",
//         img: programPlayCont1Img1,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 중앙광장",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         GXG 2025에 상륙한 <br className="md:hidden" />
//                         호요버스 <br className="hidden md:block" />
//                         어반 판타지 <br className="md:hidden" />
//                         ARPG 젠레스 존 제로. <br />
//                         뉴에리두에 오신 걸 환영합니다.
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "레드프린팅",
//         img: programPlayCont1Img2,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 중앙광장",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         나만의 디자인으로 <br />
//                         다양한 커스텀 제품을 체험
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "Microsoft",
//         img: programPlayCont1Img3,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 중앙광장",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         내 손으로 직접 경험해보는 <br />
//                         Microsoft Copilot + AI <br className="xl:hidden" />
//                         체험존
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "SYLO",
//         img: programPlayCont1Img4,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 중앙광장",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         신작 모바일 게임 플레이 체험 및 <br />
//                         리워드 미션 이벤트
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "클라우디드 레오파드 엔터테인먼트코리아",
//         img: programPlayCont1Img5,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 중앙광장",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         궤적 시리즈 첫 작품의 풀 리메이크
//                         <br />
//                         「하늘의 궤적 the 1st」타이틀 체험존
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "슈퍼셀 타운",
//         img: programPlayCont1Img6,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 북측광장 A",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         GXG 2025에 슈퍼셀 타운이 <br className="md:hidden" />
//                         등장! <br />
//                         모두가 사랑하는 인기 게임 <br className="md:hidden" />
//                         클래시 <br className="hidden md:block" />
//                         오브 클랜, 클래시 로얄, <br className="md:hidden" />
//                         브롤스타즈가 전부 한 자리에?
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "스마일게이트(게임 접근성)",
//         img: programPlayCont1Img7,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 북측광장 A",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         게임 접근성 보조기기 <br />
//                         전시 및 체험
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "굴뚝강아지 (빨간포션)",
//         img: programPlayCont1Img8,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 북측광장 A",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         게임 컨셉 에너지드링크 <br />
//                         &apos;빨간포션&apos; 체험 부스
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "성남게임힐링센터",
//         img: programPlayCont1Img9,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 북측광장 A",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         게임 습관 체크하고, <br />
//                         나만의 굿즈와 부적도 득템
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "창조공작소",
//         img: programPlayCont1Img10,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 북측광장 A",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         성우 더빙을 직접 체험할 수 <br />
//                         있는 게임사운드 스튜디오
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "오렌지커뮤니케이션즈",
//         img: programPlayCont1Img11,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 북측광장 A",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         오디오북 제작을 AI 플랫폼에서?! <br />
//                         직접 만드는 오디오북 컨텐츠
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "바다",
//         img: programPlayCont1Img12,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 북측광장 A",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         사운드 라이브러리부터 <br />
//                         AI 사운드 프로덕션까지! <br />
//                         한 곳에서 만나는 <br />
//                         게임 사운드의 모든 것
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "매직빈게임즈",
//         img: programPlayCont1Img13,
//         list: [
//             {
//                 title: "위치",
//                 content: "판교역 북측광장 A",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         누구나 즐기는 보드게임 체험과 <br />
//                         즐거운 미니게임 대회
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
// ];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// const boothList2 = [
//     {
//         title: "한림사",
//         img: programPlayCont2Img1,
//         list: [
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         게임 아트, 일러스트, <br className="xl:hidden" />
//                         애니메이션 전문 서적을 <br className="xl:hidden" />
//                         만나보세요
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "GXG Goods for Good",
//         img: programPlayCont2Img2,
//         list: [
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         오직 GXG에서만 특별한 <br className="xl:hidden" />
//                         가격으로 만나는 게임 굿즈! <br className="xl:hidden" />
//                         구매하면 자동으로 <br className="xl:hidden" />
//                         기부까지! <br />
//                         ※ 모든 수익금은 성남시한마음복지관에 <br className="xl:hidden" />
//                         기부됩니다.
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
// ];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// const boothList3 = [
//     {
//         title: "신구대학교 게임콘텐츠과",
//         img: programPlay2026Cont3Img1,
//         list: [
//             {
//                 title: "운영시간",
//                 content: "13:00 ~ 19:00 (양일 모두 운영)",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         창의와 열정이 빚어낸 <br className="xl:hidden" />
//                         신구대 게임콘텐츠과 <br className="xl:hidden" />
//                         학생들의 최신 게임 작품 전시
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
//     {
//         title: "동서울대학교 메타버스게임애니메이션과",
//         img: programPlay2026Cont3Img2,
//         list: [
//             {
//                 title: "운영시간",
//                 content: "13:00 ~ 19:00 (양일 모두 운영)",
//             },
//             {
//                 title: "내용",
//                 content: (
//                     <span>
//                         WEB 3.0의 인공지능과 <br className="xl:hidden" />
//                         블록체인을 기반으로 <br className="xl:hidden" />
//                         메타버스 게임 네트워크에서 <br />
//                         새로운 가치를 창출하는 <br className="xl:hidden" />
//                         메타버스 게임 체험 및 전시
//                     </span>
//                 ),
//                 positionTop: true,
//             },
//         ],
//     },
// ];

// GXG 캠퍼스 아케이드 참여 부스
const arcadeBoothList = [
    {
        title: "신구대학교 게임콘텐츠과",
        alt: "신구대학교 게임콘텐츠과",
        img: programPlay2026Cont3Img1,
        content: (
            <>
                창의와 열정이 빚어낸 신구대 게임콘텐츠과 <br className="xl:hidden" />
                학생들의 최신 게임 작품 전시
            </>
        ),
    },
    {
        title: (
            <>
                동서울대학교 <br className="xl:hidden" /> 메타버스게임애니메이션과
            </>
        ),
        alt: "동서울대학교 메타버스게임애니메이션과",
        img: programPlay2026Cont3Img2,
        content: (
            <>
                WEB 3.0의 인공지능과 블록체인을 기반으로 <br />
                메타버스 게임 네트워크에서 새로운 가치를 <br className="xl:hidden" />
                창출하는 메타버스 게임 체험 및 전시
            </>
        ),
    },
];

// 브랜드 체험존 참여 부스
const brandBoothList = [
    {
        title: "브롤스타즈 X 성남게임힐링센터",
        img: programPlay2026Cont4Img1,
        place: "판교역 북측광장 A",
        content: (
            <>
                나만의 브롤러 그리기와 <br />
                게임 태도 점검, <br className="sm:hidden" />
                네컷 사진 촬영 체험!
            </>
        ),
    },
    {
        title: "창조공작소",
        img: programPlay2026Cont4Img2,
        place: "판교역 북측광장 A",
        content: (
            <>
                성우 더빙을 직접 체험할 수 있는 <br />
                게임사운드 스튜디오
            </>
        ),
    },
    {
        title: "Audia",
        img: programPlay2026Cont4Img3,
        place: "판교역 북측광장 A",
        content: (
            <>
                AI 기술로 게임과 콘텐츠의 <br />
                사운드 제작을 더 쉽고 빠르게 <br />
                만드는 오디오 AI 기업
            </>
        ),
    },
    {
        title: "매직빈게임즈",
        img: programPlay2026Cont4Img4,
        place: "판교역 북측광장 A",
        content: (
            <>
                누구나 즐기는 보드게임 체험과 <br />
                즐거운 미니게임 대회
            </>
        ),
    },
    {
        title: "한림사",
        img: programPlay2026Cont4Img5,
        place: "판교역 북측광장 A",
        content: (
            <>
                게임 아트, 일러스트, <br className="sm:hidden" />
                애니메이션 등 <br />
                다양한 전문 서적을 만나보세요
            </>
        ),
    },
];

// 부스 카드 안 항목 라벨(위치/내용). 앞의 그라디언트 dot 포함 — 다른 부스 목록과 동일 패턴.
// 카드는 모바일 1단 → md 2단 → xl 3단. xl(시안) 사이즈에서 모바일 사이즈로 한 번에 떨어지면
// 태블릿에서 글자가 급격히 작아 보이므로, md 구간에 중간 사이즈를 한 단계 둔다.
const boothLabelClass =
    "relative w-[84px] shrink-0 pl-[16px] font-['GongGothicMedium'] text-[16px] after:absolute after:left-0 after:top-[5px] after:size-[8px] after:rounded-full after:bg-gradient-to-r after:from-[#00A8A0] after:to-[#00B8BB] after:content-[''] md:w-[92px] md:pl-[18px] md:text-[17px] md:after:top-[7px] xl:w-[100px] xl:pl-[20px] xl:text-[20px] xl:after:top-[9px]";

const programList = [
    {
        title: "GXG 코스튬 체험존",
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            9.11 (금) ~ 9.12 (토) 13:00 ~ 20:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            판교역 중앙광장
                        </p>
                    </li>
                    <li className="flex flex-col gap-[16px] md:gap-[40px]">
                        <div className="flex items-start gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                다양한 코스프레 의상을 착용하고 <br className="block sm:hidden" />
                                게임 속 캐릭터가 되어보는 <br className="block sm:hidden" />
                                참여형 체험 프로그램! <br />
                                게임 속 캐릭터를 현실에서 <br className="block sm:hidden" />
                                직접 만나고 체험해보세요!
                            </p>
                        </div>
                        {/* <div className="flex flex-col gap-[20px]">
                        <p className="text-[20px] font-['GongGothicMedium'] md:text-[28px]">부스 소개</p>
                        <ul className="flex flex-col gap-[20px] md:flex-row md:gap-x-[16px] md:gap-y-[20px] md:flex-wrap">
                            {boothList.map((booth, i) => (
                                <li
                                    key={`booth_${i}`}
                                    className="w-full flex flex-col md:w-[calc(50%-8px)] xl:w-[calc(33.333%-10.666px)]"
                                >
                                    <img src={booth.img} alt={booth.title} className="w-full" />
                                    <div className="flex-1 bg-[#F1F4F9] p-[20px_12px] flex flex-col gap-[16px] md:p-[20px] md:gap-[24px]">
                                        <div className="flex gap-[8px] items-center md:gap-[12px]">
                                            <p className="text-center text-white font-['GongGothicMedium'] text-[14px] size-[28px] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] rounded-full leading-[28px] md:text-[20px] md:size-[40px] md:leading-[41px]">
                                                {i < 9 ? `0${i + 1}` : i + 1}
                                            </p>
                                            <p className="flex-1 text-[18px] font-['GongGothicMedium'] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] bg-clip-text text-transparent md:text-[24px]">
                                                {booth.title}
                                            </p>
                                        </div>
                                        <ul className="flex flex-col gap-[8px] md:gap-[16px]">
                                            {booth.list.map((item, j) => (
                                                <li
                                                    key={`booth_${i}_${j}`}
                                                    className={`flex${item.positionTop ? "" : " items-center"}`}
                                                >
                                                    <p className="w-[84px] font-['GongGothicMedium'] relative after:absolute after:top-[5px] after:left-0 after:content-[''] after:size-[8px] after:bg-gradient-to-r after:from-[#00A8A0] after:to-[#00B8BB] after:rounded-full pl-[16px] md:w-[108px] md:text-[20px] md:pl-[20px] md:after:top-[9px]">
                                                        {item.title}
                                                    </p>
                                                    <p className="flex-1 font-['GongGothicLight'] md:text-[18px]">
                                                        {item.content}
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div> */}
                    </li>
                </ul>
                {/* 캡션(GXG 코스튬 체험존)·하단 그라디언트·1px #DDD 테두리가 모두 이미지에 포함된 1.5배수 소스.
                    CSS border 를 주면 2겹이 되므로 주지 않는다. */}
                <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                    <img src={programPlay2026Cont1Img1} alt="GXG 코스튬 체험존" className="w-full" />
                </div>
            </div>
        ),
    },
    {
        title: "GXG 플레이 라운지",
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            9.11 (금) ~ 9.12 (토) 13:00 ~ 21:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            판교역 북측광장 A
                        </p>
                    </li>
                    <li className="flex flex-col gap-[16px] md:gap-[40px]">
                        <div className="flex items-start gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            {/* <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            다양한 게임사 굿즈부터 게임 아트, <br className="md:hidden" />
                            일러스트북 까지! <br />
                            GXG 마켓에서 축제를 즐기는 <br className="md:hidden" />
                            또다른 재미를 느껴보세요!
                        </p> */}
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                즐거움이 가득한 <br className="block sm:hidden" />
                                인기 콘솔 게임 테마파크!
                                <br />
                                플레이 라운지에서 다양한 게임을 체험해보세요!
                            </p>
                        </div>
                        {/* <div className="flex flex-col gap-[20px]">
                        <p className="text-[20px] font-['GongGothicMedium'] md:text-[28px]">부스 소개</p>
                        <ul className="flex flex-col gap-[20px] md:flex-row md:gap-x-[16px] md:gap-y-[20px] md:flex-wrap xl:flex-col">
                            {boothList2.map((booth, i) => (
                                <li
                                    key={`booth_${i}`}
                                    className="w-full flex flex-col md:w-[calc(50%-8px)] xl:w-full xl:flex xl:flex-row"
                                >
                                    <img src={booth.img} alt={booth.title} className="w-full xl:w-[340px]" />
                                    <div className="flex-1 bg-[#F1F4F9] p-[20px_12px] flex flex-col gap-[16px] md:p-[20px] md:gap-[24px] xl:flex-1 xl:p-[20px_40px] xl:justify-center">
                                        <div className="flex gap-[8px] items-center md:gap-[12px]">
                                            <p className="text-center text-white font-['GongGothicMedium'] text-[14px] size-[28px] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] rounded-full leading-[28px] md:text-[20px] md:size-[40px] md:leading-[41px]">
                                                {i < 9 ? `0${i + 1}` : i + 1}
                                            </p>
                                            <p className="text-[18px] font-['GongGothicMedium'] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] bg-clip-text text-transparent md:text-[24px]">
                                                {booth.title}
                                            </p>
                                        </div>
                                        <ul className="flex flex-col gap-[8px] md:gap-[16 px]">
                                            {booth.list.map((item, j) => (
                                                <li
                                                    key={`booth_${i}_${j}`}
                                                    className={`flex${item.positionTop ? "" : " items-center"}`}
                                                >
                                                    <p className="text-[16px] w-[84px] font-['GongGothicMedium'] relative after:absolute after:top-[5px] after:left-0 after:content-[''] after:size-[8px] after:bg-gradient-to-r after:from-[#00A8A0] after:to-[#00B8BB] after:rounded-full pl-[16px] md:w-[108px] md:text-[20px] md:pl-[20px] md:after:top-[9px]">
                                                        {item.title}
                                                    </p>
                                                    <p className="text-[16px] flex-1 font-['GongGothicLight'] md:text-[18px]">
                                                        {item.content}
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div> */}
                    </li>
                </ul>
                {/* 이미지 파일에 1px #DDD 테두리가 포함돼 있어 CSS border 를 주지 않는다(주면 2겹). */}
                <img
                    src={programPlay2026Cont2Img1}
                    alt="GXG 플레이 라운지 2025년 현장사진"
                    className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0"
                />
            </div>
        ),
    },
    {
        title: "브랜드 체험존",
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        9.11 (금) ~ 9.12 (토) 13:00 ~ 21:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        판교역 북측광장 A
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>내용</p>
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        GXG 2026와 함께 하는 <br className="block sm:hidden" />
                        다양한 브랜드를 체험해보세요!
                    </p>
                </li>
                <li>
                    <ul className="flex flex-wrap gap-[20px]">
                        {brandBoothList.map((booth, i) => (
                            <li
                                key={`brand_booth_${i}`}
                                className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc((100%-40px)/3)]"
                            >
                                {/* 이미지 파일에 1px #DDD 테두리가 포함돼 있어 CSS border 를 주지 않는다(주면 2겹). */}
                                <img
                                    src={booth.img}
                                    alt={booth.title}
                                    className="aspect-[640/420] w-full bg-white object-contain"
                                />
                                <div className="flex flex-1 flex-col gap-[16px] bg-[#F1F4F9] p-[20px_12px] md:gap-[20px] md:p-[20px_16px] xl:gap-[24px] xl:p-[20px]">
                                    <div className="flex items-center gap-[8px] md:gap-[10px] xl:gap-[12px]">
                                        <p className="size-[28px] shrink-0 rounded-full bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] text-center font-['GongGothicMedium'] text-[14px] leading-[28px] text-white md:size-[34px] md:text-[17px] md:leading-[35px] xl:size-[40px] xl:text-[20px] xl:leading-[41px]">
                                            0{i + 1}
                                        </p>
                                        <p className="flex-1 bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] bg-clip-text font-['GongGothicMedium'] text-[18px] text-transparent md:text-[21px] xl:text-[24px]">
                                            {booth.title}
                                        </p>
                                    </div>
                                    <ul className="flex flex-col gap-[8px] md:gap-[12px] xl:gap-[16px]">
                                        <li className="flex items-start gap-[8px]">
                                            <p className={boothLabelClass}>위치</p>
                                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[17px] xl:text-[18px]">
                                                {booth.place}
                                            </p>
                                        </li>
                                        <li className="flex items-start gap-[8px]">
                                            <p className={boothLabelClass}>내용</p>
                                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[17px] xl:text-[18px]">
                                                {booth.content}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        ))}
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: <p className="flex">Cool Station</p>,
        // title: (
        //     <p className="flex">
        //         Cool Station with
        //         <br className="block sm:hidden" /> 동아오츠카
        //     </p>
        // ),
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            9.11 (금) ~ 9.12 (토) 13:00 ~ 21:00
                            <br />
                            &#8251; 소진 시 운영이 조기 종료될 수 있습니다.
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            판교역 북측광장 A
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            GXG 2026를 에너지 넘치게 <br className="block sm:hidden" />
                            즐기는 더욱 특별한 방법!
                            <br />
                            시원한 음료와 함께 <br className="block sm:hidden" />
                            잠시 쉬어가세요!
                        </p>
                    </li>
                </ul>
                {/* <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                    <img src={programPlayCont5Img1} alt="이미지" className="w-full" />
                </div> */}
                <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                    <img src={programPlay2026Cont5Img1} alt="Cool Station" className="w-full border border-[#DDD]" />
                </div>
            </div>
        ),
    },
    {
        title: "GXG 캠퍼스 아케이드",
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[24px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                9.11 (금) ~ 9.12 (토) 13:00 ~ 20:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교 테크원 2층
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:items-center md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                게임 관련 학과 학생들이
                                <br className="block sm:hidden" /> 제작한 게임을 체험해보세요!
                            </p>
                        </li>
                    </ul>
                    {/* <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                    <img src={programPlayCont3Img1} alt="이미지" className="w-full" />
                </div> */}
                </div>
                <div className="flex flex-col gap-[16px] md:gap-[20px]">
                    <p className="font-['GongGothicMedium'] text-[20px] md:text-[28px]">부스 소개</p>
                    <ul className="flex flex-col gap-[20px] md:flex-row md:flex-wrap md:gap-x-[16px] md:gap-y-[20px] xl:flex-col">
                        {arcadeBoothList.map((booth, i) => (
                            <li
                                key={`booth_${i}`}
                                className="flex w-full flex-col md:w-[calc(50%-8px)] xl:w-full xl:flex-row"
                            >
                                <img
                                    src={booth.img}
                                    alt={booth.alt}
                                    className="aspect-[340/240] w-full border border-[#DDD] object-contain xl:aspect-auto xl:h-[240px] xl:w-[340px] xl:shrink-0"
                                />
                                <div className="flex flex-1 flex-col gap-[16px] border border-t-0 border-[#DDD] bg-[#F1F4F9] p-[20px_12px] md:gap-[24px] md:p-[20px] xl:justify-center xl:border-l-0 xl:border-t xl:p-[20px_40px]">
                                    <div className="flex items-center gap-[8px] md:gap-[12px]">
                                        <p className="size-[28px] rounded-full bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] text-center font-['GongGothicMedium'] text-[14px] leading-[28px] text-white md:size-[40px] md:text-[20px] md:leading-[41px]">
                                            0{i + 1}
                                        </p>
                                        <p className="flex-1 bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] bg-clip-text font-['GongGothicMedium'] text-[18px] text-transparent md:text-[24px]">
                                            {booth.title}
                                        </p>
                                    </div>
                                    <div className="flex items-start gap-[8px]">
                                        {/* <p className="relative w-[84px] pl-[16px] font-['GongGothicMedium'] text-[16px] after:absolute after:left-0 after:top-[5px] after:size-[8px] after:rounded-full after:bg-gradient-to-r after:from-[#00A8A0] after:to-[#00B8BB] after:content-[''] md:w-[108px] md:pl-[20px] md:text-[20px] md:after:top-[9px]">
                                            내용
                                        </p> */}
                                        <p className="flex-1 font-['GongGothicLight'] text-[16px] md:text-[18px]">
                                            {booth.content}
                                        </p>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        ),
    },
];

export default function Play() {
    return (
        <>
            <div className="p-[48px_0_20px] font-['GongGothicLight'] text-[12px] md:text-[18px] xl:pt-[60px] xl:text-right xl:text-[24px]">
                * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
            </div>
            <ProgramAccordion
                list={programList}
                design="2026"
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
                hideItemBorder
            />
        </>
    );
}
